// extracted by mini-css-extract-plugin
export default {"cells":"styles_cells__KK3Co","cell":"styles_cell__1zvrW","cellContent":"styles_cellContent__2qwj5","cellPrice":"styles_cellPrice__4BfvC"};